import React, { useEffect, useRef, useState } from "react";

const PayPalPlus = ({ detailsPago, refButton, handlerLoaderShow, handlerLoaderHide, setDisabledButton }) => {
  const paypalRef = useRef(null); // Referencia al div donde se insertará el iframe
  const [pppInstance, setPppInstance] = useState(null); // Estado para mantener la instancia de PayPal Plus

  const scriptId = "paypal-plus-script";

  // Función para cargar el script de PayPal Plus dinámicamente si aún no está cargado
  const loadPayPalPlusScript = () => {
    const scriptDOM = document.getElementById(scriptId);

    // script agregado al DOM
    if (scriptDOM) {
      initPayPalPlus();
    }

    // script sin agregar al DOM
    if (!scriptDOM) {
      const script = document.createElement("script");
      script.src = "https://www.paypalobjects.com/webstatic/ppplusdcc/ppplusdcc.min.js";
      script.id = scriptId;
      script.async = true;
      script.onload = () => {
        initPayPalPlus(); // Inicializamos PayPal Plus solo cuando el script ha sido cargado
      };
      script.onerror = () => {
        handlerLoaderHide();
        console.error("Error loading PayPal Plus script");
      };

      document.body.appendChild(script);
    }
  };

  const handleClickButton = () => {
    pppInstance.doContinue();
    return false;
  };

  // Inicializar el iframe de PayPal Plus solo cuando el script esté cargado
  const initPayPalPlus = () => {
    if (!detailsPago.links) {
      handlerLoaderHide();
      console.error("approvalUrl is missing.");
      return;
    }

    const approvalUrlFilter = detailsPago.links.filter((link) => link.rel === "approval_url");

    if (window.PAYPAL && window.PAYPAL.apps && !pppInstance && approvalUrlFilter) {
      const ppp = window.PAYPAL.apps.PPP({
        approvalUrl: approvalUrlFilter[0].href,
        placeholder: paypalRef.current.id,
        preselection: "none",
        surcharging: false,
        hideAmount: false,
        mode: detailsPago.mode,
        country: "MX",
        language: "es_MX",
        buttonLocation: "outside",
        disallowRememberedCards: true,
        rememberedCards: "",
        useraction: "continue",
        payerEmail: detailsPago.client.payerEmail,
        payerFirstName: detailsPago.client.payerFirstName,
        payerLastName: detailsPago.client.payerLastName,
        payerPhone: detailsPago.client.payerPhone,
        payerTaxId: "",
        payerTaxIdType: "",
        merchantInstallmentSelectionOptional: true,
        hideMxDebitCards: false,
        iframeHeight: "",
        disableContinue: () => {
          setDisabledButton(true);
        },
        enableContinue: () => {
          setDisabledButton(false);
        },
        // al completar pago
        onContinue: async function (rememberedCards, payerId, token, term) {
          handlerLoaderShow();
          const params = new URLSearchParams({
            usuario: window.btoa(detailsPago.client.id),
            recibo: window.btoa(detailsPago.invoiceid),
            payerID: window.btoa(payerId),
            paymentID: window.btoa(detailsPago.id),
            paypalMode: detailsPago.mode,
            token: detailsPago.token,
            c_type: detailsPago.c_type,
          });

          const payURL = "ExecutePayment.php?" + params.toString();

          window.location.replace(process.env.REACT_APP_CLIENTES_BASE_URL + payURL);
        },
        // carga de formulario completa
        onLoad: () => {
          handlerLoaderHide();
        },
      });

      setPppInstance(ppp); // Guardar la instancia de PayPal Plus
    } else {
      handlerLoaderHide();
    }
  };

  useEffect(() => {
    // Cargar el script de PayPal Plus al montar el componente
    loadPayPalPlusScript();

    if (pppInstance) {
      refButton.current.addEventListener("click", handleClickButton);
    }

    // Limpiar el listener y la instancia de PayPal Plus cuando el componente se desmonte
    return async () => {
      if (pppInstance) {
        await pppInstance.doCheckout("close"); // Cierra el iframe de PayPal Plus
        refButton.current.removeEventListener("click", handleClickButton);
      }
    };
  }, [pppInstance]);

  return <div id="ppplus" ref={paypalRef} style={{ width: "100%" }}></div>;
};

export default PayPalPlus;
